RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Section = Marionette.CompositeView.extend({

        ui: {
            caret: '.section-caret',
            collapsable: 'ul.collapse'
        },
        events: {
            'show.bs.collapse @ui.collapsable': 'onShown',
            'hide.bs.collapse @ui.collapsable': 'onHidden'
        },
        className: function () {
            const me = this;
            return me.model.get('expandable') ? 'section panel panel-default' : 'section section-single';
        },
        childViewContainer: 'ul',
        getChildView: function (item) {

            if (item.get('isGroup')) {
                return views.SectionItemGroup;
            }

            return (item.get('stateless') ? views.SectionLink : views.SectionItem);
        },
        template: '#shellSectionTemplate',
        childViewOptions: function (model) {

            if (model.get('isGroup')) {
                const items = model.get('items') || [];
                const collection = new Backbone.Collection(items);

                return {
                    model: model,
                    collection: collection
                };
            }

            const result = {
                active: model.get('active')
            };
            return result;
        },

        initialize: function (options) {

            const me = this;
            RivalIQ.state.utils.bindStateEvents(me, _.extend({}, options, me.model.toJSON()));
        },

        toggleCaret: function (isDown) {
            const me = this;
            me.model.set('expanded', isDown, {
                silent: true
            });
            me.ui.caret.toggleClass('fa-caret-down', Boolean(isDown));
            me.ui.caret.toggleClass('fa-caret-left', !isDown);
        },

        onShown: function (e) {
            const me = this;
            const isDown = true;

            if (e) {
                const name = $(e.target).data('name');
                RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SideBarSectionExpand, {
                    name: name
                });

                // find the children and attach popovers
                if (me.model.get('forcePopoverAttachment')) {
                    _.each(me.children._views, function (childView) {
                        if (childView.attachPopovers) {
                            childView.attachPopovers();
                        }
                    });
                }

            }

            me.toggleCaret(isDown);
        },

        onHidden: function () {
            const me = this;
            const isDown = false;

            me.toggleCaret(isDown);
        },

        hasActiveModel: function () {

            const me = this;

            return Boolean(App.utils.findActiveItem(me.collection, function (item) {
                return _.get(item, ['active']);
            }));
        },

        templateHelpers: function () {

            const me = this;
            const model = me.model;

            // NOTE we have to call this manually for now
            // TODO this should be handled by a first class mixin concept
            const navigableHelpers = App.mixins.Navigable.templateHelpers.apply(me, arguments);
            const result = _.extend(navigableHelpers, {
                id: model.id || model.cid,
                hr: Boolean(model.get('hr')),
                expandable: Boolean(model.get('expandable')),
                expanded: Boolean(model.get('expandable')) && (me.hasActiveModel() || Boolean(me.model.get('expanded')))
            });

            return result;
        },

        addChild: function (item) {
            const me = this;
            const itm = item.toJSON();
            if (_.isUndefined(itm.display) || _.result(itm, 'display')) {
                Marionette.CollectionView.prototype.addChild.apply(me, arguments);
            }
        },

        onShow: function () {
            const me = this;
            me.$el.addClass(me.model.get('className'));
        }
    });

});
